// store/modules/userList.js
import api from "@/utils/api";
import { createListModule } from "@/store/utils/createListModule";

export default createListModule(api.getCheckInList, {
  listKey: "data",
  extraGetters: {
    checkInTypesList: (state) => {
      function addCheckInTypes(checkIns) {
        const now = Math.floor(Date.now() / 1000); // 当前时间的秒级时间戳

        // 判断两个日期是否为同一天
        const isSameDay = (date1, date2) => {
          return (
            date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate()
          );
        };

        return checkIns.map((checkIn, idx) => {
          const timeWindowDate = new Date(checkIn.timeWindow * 1000);
          const currentDate = new Date();
          const index = idx + 1;
          if (checkIn.checkedInAt !== null) {
            return { ...checkIn, type: "Checked", index };
          }
          if (isSameDay(timeWindowDate, currentDate)) {
            return { ...checkIn, type: "Today", index };
          }
          if (now >= checkIn.timeWindow) {
            return { ...checkIn, type: "Missed", index };
          }
          return { ...checkIn, type: "NotChecked", index };
        });
      }
      return addCheckInTypes(state.list);
    },
  },
});
